import { html, LitElement } from 'lit';
import { TagKey } from '@cof/tag-catalog-fs-lienholder-mfe';
import { style } from './lender-name.style.js';
import { DebugService } from '@services/debug.service';
import { stratum } from '../../../constants/stratum.js';
import { LenderService } from '@services/lender.service';
import '@cof/fs-text-field-wc/fs-text-field.js';
import { customElement } from 'lit/decorators.js';

@customElement('refi-lender-name')
export class RefiLenderNameComponent extends LitElement {
  constructor() {
    super();
    this.debug = new DebugService('RefiLenderName');
    this.lenderInfo = {};
  }

  static properties = {
    lenderName: { type: String, attribute: 'lender-name', reflect: true },
  };

  static styles = [style];

  debug: DebugService;
  lenderInfo: any;
  lenderName: any;

  connectedCallback() {
    super.connectedCallback();
    this.lenderInfo = LenderService.getLienholder();
    this.lenderName = this.lenderInfo.lienHolderName;
  }

  render() {
    this.debug.log('rendered lender-name');
    return html`
      <div class="lender__name">
        <fs-text-field
          id="lenderName"
          autocomplete="off"
          name="lenderName"
          type="text"
          value-missing-message="Please enter your lender name"
          helper="This should be who your auto loan is with now."
          maxLength="50"
          required
          @blur="${this.manualFillLienholderName}"
          value="${this.lenderName}"
        >
          <slot name="lenderName">Lender name</slot>
        </fs-text-field>
      </div>
    `;
  }

  manualFillLienholderName(e: any | null) {
    this.debug.log('lienholder name on blur');
    this.dispatchEvent(new CustomEvent('unsaved-fields'));
    if (e && !e.currentTarget.checkValidity()) {
      stratum.publishTag(TagKey.LIENHOLDER_FIELD_VALIDATION_ERROR_MESSAGE, {
        replacements: {
          value: 'lender name',
        },
      });
    }
    stratum.publishTag(TagKey.LIENHOLDER_LENDER_NAME_EDITED);
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'refi-lender-name': RefiLenderNameComponent;
  }
}
